import html2pdf from 'html2pdf.js';

export async function downloadSalesDocPdf(
  doc: { id?: string; title?: string; reference_number?: string },
  targetElement?: HTMLElement | null
): Promise<void> {
  const sheetId = `sheet-${doc.id || 'new'}`;
  const sheetEl =
    targetElement ||
    document.getElementById(sheetId) ||
    (document.querySelector('.dt-quotation-template .sheet') as HTMLElement | null);

  if (!sheetEl) {
    console.warn(`[downloadSalesDocPdf] No sheet found for doc ${doc.id || 'new'}, falling back to window.print`);
    window.print();
    return;
  }

  // Find parent style element if present to preserve custom CSS
  const styleEl = document.querySelector('.dt-quotation-template style');

  // Clone the sheet element
  const clone = sheetEl.cloneNode(true) as HTMLElement;

  // Remove interactive editing controls, buttons, toolbars, and file inputs
  clone.querySelectorAll('.rowdel, button, .toolbar, .hint, input[type="file"]').forEach((el) => el.remove());
  clone.querySelectorAll('[contenteditable]').forEach((el) => {
    el.removeAttribute('contenteditable');
  });

  // Ensure clean look for PDF rendering
  clone.style.boxShadow = 'none';
  clone.style.margin = '0 auto';
  clone.style.width = '210mm';
  clone.style.maxWidth = '210mm';
  clone.style.minHeight = '297mm';
  clone.style.background = '#ffffff';

  // Create an off-screen container with exact A4 sheet proportions
  const container = document.createElement('div');
  container.className = 'dt-quotation-template';
  container.style.position = 'fixed';
  container.style.top = '-99999px';
  container.style.left = '-99999px';
  container.style.width = '210mm';
  container.style.padding = '0';
  container.style.margin = '0';
  container.style.background = '#ffffff';
  container.style.zIndex = '-9999';

  if (styleEl) {
    container.appendChild(styleEl.cloneNode(true));
  }
  container.appendChild(clone);
  document.body.appendChild(container);

  const cleanTitle = (doc.title || doc.reference_number || 'sales-document')
    .replace(/[^\w\d-_]+/gi, '_')
    .replace(/^_+|_+$/g, '');
  const filename = `${cleanTitle}.pdf`;

  const opt = {
    margin: [0, 0, 0, 0],
    filename,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      letterRendering: true,
      logging: false,
    },
    jsPDF: {
      unit: 'mm',
      format: 'a4',
      orientation: 'portrait',
    },
  };

  try {
    const pdfLib = (html2pdf as any).default || html2pdf;
    await pdfLib().set(opt).from(clone).save();
  } finally {
    if (document.body.contains(container)) {
      document.body.removeChild(container);
    }
  }
}
